/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsLocation = {
  init: function($section) {
     $('.store-locate-section .column').click(function(){
        var index = $(this).data('index');
        $('.store-locate-section .column').removeClass('is-active');
        $(this).addClass('is-active');
        $('.map-element').removeClass('is-visible');
        $('.map-'+index).addClass('is-visible');    
    })
  },
  unload: function($section) {

  }
}

/******/ })()
;